define([
	'internal_util/Util',
	'view/UIView',
	'lib/jquery'
], function (
	Util,
	UIView,
	jQuery
) {
	'use strict';

	/**
	 * TextView class
	 */
	function TextView(isError) {
		var _view = jQuery('<div class="skIdS_text-container"></div>');
		var _isError = isError ? isError : false;

		UIView.call(this);


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function () {
			// nothing to do
		};

		this.addNewLine = function (count) {
			var i;

			if (typeof count !== 'number' || count < 1) {
				count = 1;
			}

			for (i = 0; i < count; i++) {
				_view.append('<br>');
			}
		};

		this.addText = function (text, callbacks) {
			var links;
			if (_isError) {
				text = jQuery('<span class="alert alert-warning">' + text + '</span>');
			} else {
				text = jQuery('<span>' + text + '</span>');
			}
			links = text.find('a[href="javascript:;"]');

			if (links.length > 0 && typeof callbacks !== 'undefined') {
				if (!Util.isArray(callbacks)) {
					callbacks = [ callbacks ];
				}

				links.each(function (index) {
					if (index < callbacks.length) {
						jQuery(this).on('click', function (event) {
							event.preventDefault();

							Util.callCallbacks(callbacks[index]);
						})
					}
				});
			}

			_view.append(text);
		};

		this.addLink = function (description, callback) {
			var $link = jQuery('<a href="javascript:;">' + description + '</a>');

			$link.on('click', function (event) {
				event.preventDefault();

				Util.callCallbacks(callback);
			});

			_view.append($link);
		};
		
		this.addImage = function (url) {
			var $link = jQuery("<img src='"+ url +"'style='max-width: 250px;'/>");

			_view.append($link);
		};
		
		this.addVideo = function (url, poster) {
			var $link = jQuery("<div id='skIdS_identity-fido_container' style='text-align: center;'>" +
						"<video autoplay muted loop poster='" +poster+ "' style='width: 250px;'>" +
							"<source src='" +url+ "' type='video/mp4' />" +
						"</video></div>");

			_view.append($link);
		};
	}

	TextView.prototype = Object.create(UIView.prototype);

	return TextView;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/TextView.js
// module id = 31
// module chunks = 1